import { useGetAllSalvagesMutation } from "../../../features/services/apis/Home/SalvageExternalApiService";
import { useEffect, useState } from "react";
import baseUrl from "../../../features/services/service";
import { Salvage } from "Application/features/models/Home/Salvage";
import React from "react";
import ModalForm from "./SalvageDetails";
import BidForm from "./BidForm";
//Icons Imports
import { growlError, userManagementUtil } from "@siba/utilities";
import { formatNumberCurrency, formatUKDate, useGenericFormMethods } from "Application/Pages/formMethods/genericMethods";
import { SmallScreenDialog, LargeScreenDialog } from "@siba/components";
import { useSaveExternalBidMutation } from "Application/features/services/apis/Home/ExternalBidApiService";
import { ExternalBid } from "Application/features/models/Home/ExternalBid";
import "./car-item.css";
import Spinner from "../../../Components/SalvageWebComponents/Spinner";
import CarRentalIcon from '@mui/icons-material/CarRental';
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { createUseStyles } from "react-jss";
import { queryResponse } from "Application/features/services/backends/sibaApis";
import { Alert, Paper, Snackbar, Typography } from "@mui/material";

// Define your styles using createUseStyles
const useStyles = createUseStyles({
  salvageLoader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh', // Adjust the height as needed
  },
  loadingMessage: {
    color: '#007bff', // Blue color for loading message
    fontSize: '18px',
  },
  noSalvagesMessage: {
    color: '#dc3545', // Red color for no salvages found message
    fontSize: '18px',
  },
});

const SalvageList: React.FC = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const [displayedItems, setDisplayedItems] = useState<Salvage[]>([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredItems, setFilteredItems] = useState<Salvage[]>([]);

    const classes = useStyles();

    const handlePageChange = (pageNumber: number) => {
        const totalPages = Math.ceil(genericMethods.modelCollection.length / itemsPerPage);
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            const indexOfLastItem = pageNumber * itemsPerPage;
            const indexOfFirstItem = indexOfLastItem - itemsPerPage;
            setDisplayedItems(genericMethods.modelCollection.slice(indexOfFirstItem, indexOfLastItem));
        }
    };

    const [getSalvages] = useGetAllSalvagesMutation();
    const [save] = useSaveExternalBidMutation();
    /**
     * genericMethods is generic method, property  generator tha returns
     * default/ generic event handlers for a setup form.
     * @prop Name is defaulted as the name of the setup and shown on the form.
     * @prop saveMethod - a save endpoint/ function for the setup.
     * @prop removeMethod - points to the remove method, endpoint for the setup.
     * @prop updateMethod - points to the update method / endpont for the setup.
     * @returns generic methods / properties for setup form.
     * @type IAddressType
     * **/
    const genericMethods = useGenericFormMethods<Salvage>({
        formName: "Salvage Details",
        getAllMethod: getSalvages
    });

    const bidGenericMethods = useGenericFormMethods<ExternalBid>({
        formName: "Create Bid",
        saveMethod: save
    });

    const [isLoadingSalvages, setIsloadingSalvages] = useState(false);

    const handleGetAll = async () => {
        genericMethods.setModelCollection([]);
        setIsloadingSalvages(true);
        const response: queryResponse<any> | any = await getSalvages();
        if (response.data) {
            genericMethods.setModelCollection(response.data as Salvage[]);
        setIsloadingSalvages(false);

        }else{
                    setIsloadingSalvages(false);

        }

    };
    useEffect(() => {
        try {
            handleGetAll();
        } catch (e) {
            growlError("Something went wrong");
        }
    }, []);
    useEffect(() => {
        if (filteredItems.length > 0) {
            setDisplayedItems(filteredItems.slice(indexOfFirstItem, indexOfLastItem));
        } else {
            setDisplayedItems(genericMethods.modelCollection.slice(indexOfFirstItem, indexOfLastItem));
        }
    }, [filteredItems, genericMethods.modelCollection, itemsPerPage, indexOfFirstItem, indexOfLastItem]);

    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const query = event.target.value.toLowerCase();
        const filtered = genericMethods.modelCollection.filter((item: any) => {
            const stockNumber = item.StockNumber ? item.StockNumber.toString().toLowerCase() : "";
            const condition = item.Condition ? item.Condition.toLowerCase() : "";
            const previewImagePath = item.PreviewImagePath ? item.PreviewImagePath.toLowerCase() : "";

            return stockNumber.includes(query) || condition.includes(query) || previewImagePath.includes(query);
        });
        setFilteredItems(filtered);
        setSearchQuery(query);
    };
    const content = 
            (<>
                {displayedItems.map((item, i) => (
                    <div className="col-lg-3 col-md-6 col-sm-12 mb-4" key={item.Id}>
                        <div style={{ width: "100%" }}>
                            <div>
                                <div className="car__item">
                                    <div className="car__img">
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                height: "200px"
                                            }}
                                        >
                                            {item.PreviewImagePath ? (
                                                <img src={`${baseUrl.backend}${item.PreviewImagePath}`} alt="" className="w-100" style={{ height: "100%", objectFit: "cover", borderRadius: "12px" }} />
                                            ) : (
                                                <DriveEtaIcon style={{ fontSize: 200, color: "#d5d5d5" }} />
                                            )}
                                        </div>
                                    </div>

                                    <div style={{display: "flex", justifyContent: "space-between", marginTop: "10px"}}>
                                        <div>
                                            <h5 style={{fontWeight: "700"}}>{item.Make}</h5> 
                                            <div style={{fontSize: "12px"}}>{item.Model}</div>
                                        </div>
                                        <div>

                                        </div>
                                    </div>

                                    <hr style={{margin: "5px 0px"}} />
                                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                            <div>
                                                <div style={{fontSize: "12px", fontWeight: "500", borderRadius: "30px", /** backgroundColor: "#2C8755", */ border: "2px solid #949494", padding: "2px 5px", margin: "5px 0px 8px 0px", color: "black", width: "115px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                                                    Starting Bid Price
                                                </div>
                                                <div style={{display: "flex", alignItems: "start"}}>
                                                    <div style={{fontSize: "12px", marginRight: "5px", fontWeight: "600"}}> {item.BidCurrency || "GHS"} </div> 
                                                    <h4>{formatNumberCurrency(item.MinimumBidAmount) || 0.0}</h4>
                                                </div>
                                            </div>
                                            <div style={{backgroundColor: "#F3F6FC", borderRadius: "8px", height: "85px", width: "95px", padding: "6px", display: "flex", flexDirection: "column", alignItems: "center"}}>
                                                
                                                <div>
                                                    <h1>{item.NumberOfBidders}</h1>
                                                </div>
                                                <div style={{display: "flex", alignItems: "center"}}>
                                                    <CarRentalIcon style={{fontSize: "25px", marginRight: "5px"}} /> <span style={{fontSize: "12px", marginRight: "5px", fontWeight: "400"}}>Bidders</span>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    <hr style={{margin: "5px 0px"}} />

                                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%"}}>
                                        <div style={{width: "33%", height: "50px", borderRight: "1px solid #ABABAB", padding: "5px 0px", display: "flex", flexDirection: "column", justifyContent: "left"}}>
                                            <div style={{fontSize: "12px"}}>Status</div>
                                            <h6 style={{fontWeight: "400"}}>
                                            {item.Status === "Available" ? (
                                                    <span className={"badge bg-success"} style={{ fontSize: "12px", fontWeight: "400" }}>
                                                        Available
                                                    </span>
                                                ) : (
                                                    <span className={"badge bg-danger"} style={{ fontSize: "12px", fontWeight: "400" }}>
                                                        Unavailable
                                                    </span>
                                                )}
                                            </h6> 
                                        </div>
                                        <div style={{width: "33%", height: "50px", borderRight: "1px solid #ABABAB", padding: "5px 0px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                                            <div style={{fontSize: "12px"}}>Man. Year</div>
                                            <h6 style={{fontWeight: "700"}}>{item.Year}</h6>
                                        </div>
                                        <div style={{width: "33%", height: "50px", padding: "5px 0px",  textAlign: "right"}}>                                        
                                            <div style={{fontSize: "12px"}}>Stock N#</div>
                                            <h6 style={{fontWeight: "700"}}>{item.StockNumber}</h6> 
                                        </div>
                                    </div>

                                    <hr style={{margin: "5px 0px"}} />

                                    <div style={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
                                        <div style={{ width: "2%", height: "45px", backgroundColor: "#DF5000" }}>&nbsp;</div>
                                        <div style={{ width: "98%", paddingLeft: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <h6 style={{ fontSize: "12px", fontWeight: "600", marginBottom : "10px" }}>Bid Closing Date</h6>
                                                <h4 style={{ fontSize: "18px", fontWeight: "600" }}><span className="blink">{formatUKDate(item.BidClosingDate) || "None"}</span></h4>
                                            </div>
                                            <div>
                                                <EventBusyIcon style={{fontSize: "35px", color: "#949494"}} />
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <div className="car__item-content mt-4">
                                        {/* <h5 className="section__title text-center">
                                            {item.Make} {item.Model} <span> {item.Year}</span>
                                        </h5> */}
                                        {/* <h6 style={{ color: "green" }} className="rent__price text-center mt-">
                                            Stock #: {item.StockNumber}
                                        </h6>
                                        <h6 style={{ color: "#01222B" }} className="rent__price text-center mt-">
                                            Starting Bid Price:{" "}
                                            <span>
                                                {item.BidCurrency || "GHS"} {formatNumberCurrency(item.MinimumBidAmount) || 0.0}
                                            </span>
                                        </h6> */}
                                        {/* <h6 className="rent__price text-center mt-">
                                            Bid Closing Date: <span className="blink">{formatUKDate(item.BidClosingDate) || "None"}</span>
                                        </h6> */}

                                        {/* <div className="car__item-info d-flex align-items-center justify-content-between mt-3 mb-4">
                                            <span className=" d-flex align-items-center gap-1">
                                                <h6 className="rent__price text-center mt-">Status:</h6>
                                                <i className="ri-settings-2-line"></i>{" "}
                                                {item.Status === "Available" ? (
                                                    <span className={"badge bg-success"} style={{ fontSize: "14px" }}>
                                                        Available
                                                    </span>
                                                ) : (
                                                    <span className={"badge bg-danger"} style={{ fontSize: "14px" }}>
                                                        Unavailable
                                                    </span>
                                                )}
                                            </span>
                                            <span className=" d-flex align-items-center gap-1">
                                                <h6 className="rent__price text-center mt-">Bidders:</h6>
                                                <i className="ri-timer-flash-line"></i>{" "}
                                                <span className={"badge bg-primary"} style={{ fontSize: "14px" }}>
                                                    {" "}
                                                    {item.NumberOfBidders}
                                                </span>
                                            </span>
                                        </div> */}

                                        <button
                                            className="w-50 car__item-btn car__btn-rent"
                                            style={{ color: "#fff", backgroundColor: "#949494" }}
                                            onClick={() => {
                                                if (userManagementUtil.getUserSession()) {
                                                    bidGenericMethods.handleClickOpen();
                                                    bidGenericMethods.formHandler.reset({
                                                        SalvageId: item.Id,
                                                        BidderName: `${userManagementUtil.getUserSession().firstName} ${userManagementUtil.getUserSession().lastName}`,
                                                        Status: "1",
                                                        BidderCode: userManagementUtil.getUserSession().BidderCode,
                                                        PhoneNumber: userManagementUtil.getUserSession().phoneNumber,
                                                        Email: userManagementUtil.getUserSession().email,
                                                        Address: userManagementUtil.getUserSession().PostalAddress
                                                    });
                                                } else {
                                                    return window.location.assign(window.location.origin + "/sibasalvage/login");
                                                }
                                            }}
                                        >
                                            Bid
                                        </button>
                                        <button
                                            className="w-50 car__item-btn car__btn-details"
                                            style={{ backgroundColor: "#F7001F", color: "#fff" }}
                                            onClick={() => {
                                                genericMethods.setModel(item);
                                                genericMethods.handleClickView();
                                            }}
                                        >
                                            Details
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </>
        );

    const loaderMessage = (

        isLoadingSalvages? (
            <><div className={classes.loadingMessage}>Loading... Searching for salvages</div><Spinner/></>
        
      ) : (
        <div className={classes.noSalvagesMessage}>No salvages found.</div>
      )
    )
    
    return (
        <>
            {/* =========== car Bids section ============= */}

            <div style={{ display: "flex", width: "100%" }}>
                <div className="container">
                    <div className="search__container">
                     <div>
          <p style={{ display: 'flex', justifyContent: "center" }}>
            {/* "Take a look around" text */}
            <span className="search__title">Take a look around </span>
            {/* Content of the Alert with a clickable link */}
           <span style={{width: "15em", marginLeft: "3em"}}><Alert severity="error" icon={false} style={{backgroundColor:"#E0115F"}}>
                <a href="https://starassurance.com/salvage-disclaimer.html" target="_blank" rel="noopener noreferrer" style={{fontSize: 17, textDecoration: "none", color: "#fff"}}>
                  Salvage Sales Disclaimer
                </a>
                .
            </Alert>
            </span>
          </p>
        </div>
                        <input className="search__input" type="text" placeholder="Search for salvages....." value={searchQuery} onChange={handleSearch} />
                    </div>

                    <div className="row">
                        {displayedItems.length? content: loaderMessage }

                       {displayedItems.length? <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <div
                                className="pagination"
                                style={{
                                    border: "1px solid #d5d5d5",
                                    borderRadius: "10px"
                                }}
                            >
                                <button
                                    className={`pagination-button ${currentPage === 1 ? "disabled" : ""}`}
                                    style={{
                                        padding: "8px 20px",
                                        border: "none",
                                        marginRight: "10px",
                                        borderRadius: "10px 0px 0px 10px",
                                        backgroundColor: currentPage === 1 ? "#fafafa" : "#3978D2",
                                        color: currentPage === 1 ? "#000" : "#fff"
                                    }}
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    Prev
                                </button>

                                {Array.from(Array(Math.ceil(genericMethods.modelCollection.length / itemsPerPage)), (e, i) => {
                                    // Condition to add an ellipsis between the first five pages and the last page
                                    if (i > 3 && i < Math.ceil(genericMethods.modelCollection.length / itemsPerPage) - 2 && Math.abs(i + 1 - currentPage) > 1) {
                                        return (
                                            <span key={i} style={{ margin: "10px 8px" }}>
                                                ...
                                            </span>
                                        );
                                    }

                                    return (
                                        <button
                                            key={i}
                                            className={`pagination-button ${currentPage === i + 1 ? "active" : ""}`}
                                            onClick={() => handlePageChange(i + 1)}
                                            style={{
                                                padding: "4px 12px",
                                                borderRadius: "5px",
                                                border: "1px solid #F7001F",
                                                margin: "10px 8px",
                                                backgroundColor: currentPage === i + 1 ? "#F7001F" : "#fff",
                                                color: currentPage === i + 1 ? "#fff" : "#F7001F"
                                            }}
                                        >
                                            {i + 1}
                                        </button>
                                    );
                                })}

                                <button
                                    className={`pagination-button ${currentPage === Math.ceil(genericMethods.modelCollection.length / itemsPerPage) ? "disabled" : ""}`}
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === Math.ceil(genericMethods.modelCollection.length / itemsPerPage)}
                                    style={{
                                        padding: "8px 20px",
                                        border: "none",
                                        borderRadius: "0px 10px 10px 0px",
                                        marginLeft: "10px",
                                        backgroundColor: currentPage === Math.ceil(genericMethods.modelCollection.length / itemsPerPage) ? "#fafafa" : "#3978D2",
                                        color: currentPage === Math.ceil(genericMethods.modelCollection.length / itemsPerPage) ? "#000" : "#fff"
                                    }}
                                >
                                    Next
                                </button>
                            </div>
                        </div>:""}
                    </div>
                </div>
            </div>
            <LargeScreenDialog title={"View Salvage Details"} onClose={genericMethods.handleClickClose} visible={genericMethods.modalOpen}>
                <ModalForm salvageId={genericMethods.model.Id!} />
            </LargeScreenDialog>
            <SmallScreenDialog
                title={"Place your Bid"}
                onClose={bidGenericMethods.handleClickClose}
                visible={bidGenericMethods.modalOpen}
                onSave={bidGenericMethods.handleSave(bidGenericMethods.saveType)}
            >
                <BidForm formHandler={bidGenericMethods.formHandler} />
            </SmallScreenDialog>
        </>
    );
};

export default SalvageList;
